
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ba45d82c&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MoralCheck.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-check.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ba45d82c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-check.pug"),
  /* scopeId */
  "data-v-ba45d82c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralCheck.vue
// module id = 1318
// module chunks = 1